import type { StyleXStyles } from '@stylexjs/stylex';
import { useCallback } from 'react';
import { Anchored, Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';
import { useTernaryDarkMode } from 'usehooks-ts';

import type { IContainerProps } from '~/components/utils/Container';
import logoUrl from '~/assets/logo.png';
import { Link } from '~/components/atoms/Link';

export type ILogoProps = IContainerProps & {
  href?: string;
};

const styles = stylex.create({
  exponent: {
    marginTop: 16,
    color: colorSchemeTokens.primary,
  },
  logoImage$dark: {
    filter: 'contrast(0%) brightness(200%)',
  },
});

export const Logo: React.FC<ILogoProps> = (props) => {
  const { sx, href } = props;
  const { isDarkMode } = useTernaryDarkMode();

  const renderLogo = useCallback(
    (props?: React.ComponentPropsWithoutRef<'img'> & { sx?: StyleXStyles }) => (
      <img
        {...stylex.props(isDarkMode && styles.logoImage$dark, sx)}
        src={logoUrl}
        alt="Crowdaa"
        {...props}
      />
    ),
    [isDarkMode, sx],
  );

  return (
    <Anchored
      content={
        <Text sx={styles.exponent} variant="label" size="md">
          beta
        </Text>
      }
      horizontalOrigin="right"
      verticalOrigin="top"
    >
      {href ? (
        <Link to={href} sx={sx}>
          {renderLogo()}
        </Link>
      ) : (
        renderLogo({ sx })
      )}
    </Anchored>
  );
};
